import React, { useEffect, useState } from "react";
import { ItemsService } from "../../../services/user/items.services";

const ItemModal = ({ showModal, setShowModal, handleItemSelect, itemId, childType }) => {
    const [items, setItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            if (itemId) {
                try {
                    let itemDetails = [];
                    if (childType === "Standard") {
                        itemDetails = await ItemsService.getStandardItemByMainItemId(itemId);
                    } else if (childType === "Optional") {
                        itemDetails = await ItemsService.getOptionalItemByMainItemId(itemId);
                    }
                    setItems(itemDetails);
                    if (itemDetails.length > 0) {
                        setSelectedItems([itemDetails[0]]);
                        setSelectedItems([]);
                    }
                } catch (error) {
                    console.error(`Error fetching ${childType} items:`, error);
                }
            }
        };

        if (showModal) {
            fetchItems();
        }

        return () => {
            if (!showModal) {
                setSelectedItems([]);
            }
        };
    }, [showModal, itemId, childType]);

    const handleItemCheckboxSelect = (e, item) => {
        const { checked } = e.target;
        if (checked) {
            setSelectedItems((prev) => {
                if (!prev.some(selectedItem => selectedItem.itemId === item.itemId)) {
                    return [...prev, item];
                }
                return prev;
            });
        } else {
            setSelectedItems((prev) => prev.filter((selectedItem) => selectedItem.itemId !== item.itemId));
        }
    };

    const handleSubmit = () => {
        handleItemSelect(selectedItems);
        setShowModal(false);
    };

    const getImageFromBuffer = (buffer) => {
        if (buffer?.data) {
            const blob = new Blob([new Uint8Array(buffer.data)], { type: 'image/jpeg' });
            return URL.createObjectURL(blob);
        }
        return '';
    };

    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content shadow-lg rounded">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">{childType} Items</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Image</th>
                                                    <th>Select</th>
                                                    <th>Item ID</th>
                                                    <th>Item Name</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {items.length > 0 ? (
                                                    items.map((item) => (
                                                        <tr key={item.itemId}>
                                                            <td>
                                                                <img
                                                                    src={getImageFromBuffer(item.itemImage)}
                                                                    alt={item.itemName}
                                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedItems.some(selectedItem => selectedItem.itemId === item.itemId)}
                                                                    onChange={(e) => handleItemCheckboxSelect(e, item)}
                                                                />
                                                            </td>
                                                            <td>{item.itemId}</td>
                                                            <td>{item.itemName}</td>
                                                            <td>{item.price}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            No {childType.toLowerCase()} items available for this main item.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ItemModal;
